import React from 'react';
import uniqueid from 'lodash.uniqueid';
import { jsx } from '@emotion/react';

var formatMessage = message => {
  if (Array.isArray(message)) {
    var mapResult = message.map(value => jsx(React.Fragment, {
      key: uniqueid()
    }, value));
    return jsx(React.Fragment, null, mapResult.reduce((prev, curr) => jsx(React.Fragment, null, prev, ', ', curr)));
  }

  return message;
};

export { formatMessage as default };
